import ApiHelper from "../../helpers/ApiHelper";
import BaseService from "../BaseService";

class TransactionService extends BaseService {

    static url = "transactions";
    static apis = {

    }

    constructor(repo) {
        super(repo);
        this.repo = new ApiHelper("transactions");
    }

}

export default TransactionService;